$(function() {

   $(".selectmenu").click(function() {
       $(this).toggleClass("active");
   });
    if ( $(".selectmenu").length ) {
        $(document).on('mousedown touchstart', function (e) {
            let div = $(".selectmenu");
            if (!div.is(e.target) && div.has(e.target).length === 0) { // и не по его дочерним элементам
                div.removeClass("active");
            }
        });
    }

});